'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _ajaxQueue = require('@butsandcats/ajax-queue');

var _ajaxQueue2 = _interopRequireDefault(_ajaxQueue);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Cart = function ShopifyAjaxCartWrapper(configuration) {
  'use strict';

  // Create a new var from the configuration if there is one provided

  var config = configuration || {};

  // Check each of the parameters exist and assign them to their default type if not.
  var cart = config.cart || {};
  var selectors = config.selectors || {};
  var options = config.options || {};

  // Define the default selectors and options for the class
  var defaultSelectors = {
    cart: '[data-cart]',
    cartItemCount: '[data-cart-item-count]',
    cartTotal: '[data-cart-total]',
    decreaseQuantity: '[data-minus-one]',
    increaseQuantity: '[data-plus-one]',
    itemQuantity: '[data-item-quantity]',
    staticQuantity: '[data-static]',
    staticChangeQuantity: '[data-adjust]',
    addItem: '[data-add-to-cart]',
    quickAdd: '[data-quick-add]',
    quickAddQuantity: '[data-quick-add-qty]',
    quickAddProperties: '[data-quick-add-properties]',
    removeItem: '[data-remove-item]',
    updateItem: '[data-update-item]',
    emptyTemplate: '[data-cart-template]',
    itemsContainer: '[data-item-container]'
    // This object will be used to define default callbacks, money formatting and other options
  };var defaultOptions = {
    getUrl: '/cart.json',
    timeOut: 1000

    // Create a new queue
  };this.queue = new _ajaxQueue2.default({
    method: 'POST',
    completedAllRequestsEvent: 'cart:requestsCompleted',
    completedRequestEvent: 'cart:requestCompleted'
  });

  this.defaultBeforeSend = function cartSending(type, item) {
    var response = {
      type: type,
      item: item
    };
    var sendEvent = new CustomEvent('cart:sending', {
      detail: {
        response: response
      }
    });
    document.dispatchEvent(sendEvent);
    return response;
  };

  this.defaultSuccess = function cartSuccess(response) {
    this.getCart();
  }.bind(this);

  this.defaultError = function cartError(resp) {
    var response = JSON.parse(resp);
    var errorEvent = new CustomEvent('cart:error', {
      detail: {
        response: response
      }
    });

    this.preparingItemsArray = this.createItemArray();
    document.dispatchEvent(errorEvent);
    return response;
  }.bind(this);

  // Merge and add the settings into the prototype
  this.cart = cart;
  // Keep track of items in an id centric structure
  this.items = this.createItems(cart);
  this.selectors = Object.assign(defaultSelectors, selectors);
  this.options = Object.assign(defaultOptions, options);

  // Debounce requests
  this.requestTimeout = null;
  this.preparingItemsArray = null;

  // Build the event listeners from the selectors
  this.buildEventListeners(this.selectors);
  return this;
};

// Create an object of all the relevant selectors and build event listeners from them.
Cart.prototype.buildEventListeners = function buildEventListeners(selectors) {
  'use strict';

  this.allSelectors = {
    addItem: {
      selector: selectors.addItem,
      listen: 'click',
      callback: this.addToCart.bind(this)
    },
    removeItemSelectors: {
      selector: selectors.removeItem,
      listen: 'click',
      callback: this.removeFromCart.bind(this)
    },
    decreaseQuantitySelectors: {
      selector: selectors.decreaseQuantity,
      listen: 'click',
      callback: this.decreaseQuantity.bind(this)
    },
    increaseQuantitySelectors: {
      selector: selectors.increaseQuantity,
      listen: 'click',
      callback: this.increaseQuantity.bind(this)
    },
    quickAddSelectors: {
      selector: selectors.quickAdd,
      listen: 'click',
      callback: this.quickAdd.bind(this)
    }
  };

  function on(eventName, selector, fn) {
    document.addEventListener(eventName, function (event) {
      var possibleTargets = document.querySelectorAll(selector);
      var target = event.target;
      for (var i = 0, l = possibleTargets.length; i < l; i++) {
        var el = target;
        var p = possibleTargets[i];

        while (el && el !== document) {
          if (el === p) {
            event.preventDefault();
            event.elem = p;
            return fn.call(p, event);
          }

          el = el.parentNode;
        }
      }
    });
  }

  var _iteratorNormalCompletion = true;
  var _didIteratorError = false;
  var _iteratorError = undefined;

  try {
    for (var _iterator = Object.keys(this.allSelectors)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
      var key = _step.value;
      var _allSelectors$key = this.allSelectors[key],
          listen = _allSelectors$key.listen,
          selector = _allSelectors$key.selector,
          callback = _allSelectors$key.callback;

      on(listen, selector, callback);
    }
    // return this to and the ability to chain functions
  } catch (err) {
    _didIteratorError = true;
    _iteratorError = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion && _iterator.return) {
        _iterator.return();
      }
    } finally {
      if (_didIteratorError) {
        throw _iteratorError;
      }
    }
  }

  return this;
};

/*
  Event based Functions
  All of these functions are fired from event listeners
*/
Cart.prototype.addToCart = function onClickAddToCartButton(event) {
  'use strict';

  var idInput = document.querySelector('[name=id]');
  var quantityInput = document.querySelector('[name=quantity]');
  var propertyInputs = document.querySelectorAll('[name*=properties]');

  var id = Number(idInput.value || idInput.options[idInput.selectedIndex].value);
  var quantity = Number(quantityInput.value);
  var properties = {};

  // Create an object of properties from the properties input fields
  for (var input = 0; input < propertyInputs.length; input += 1) {
    var element = propertyInputs[input];
    if (element.type === 'radio' && !element.checked) {
      continue;
    }
    var key = element.getAttribute('name').split('[')[1].split(']')[0];
    var value = element.value;
    properties[key] = value;
  }
  var data = {
    id: id,
    quantity: quantity,
    properties: properties
  };
  this.addItem(data);
};

Cart.prototype.quickAdd = function onClickQuickAddButton(event) {
  'use strict';

  var idAttribute = this.getDataAttribute(this.selectors.quickAdd);
  var qtyAttribute = this.getDataAttribute(this.selectors.quickAddQuantity);
  var propertiesAttribute = this.getDataAttribute(this.selectors.quickAddProperties);
  var id = Number(event.elem.getAttribute(idAttribute));
  var quantity = Number(event.elem.getAttribute(qtyAttribute)) || 1;
  var properties = JSON.parse(event.elem.getAttribute(propertiesAttribute));
  var data = {
    id: id,
    quantity: quantity,
    properties: properties
  };
  var config = {
    beforeRequestType: 'quickAdd'
  };
  this.addItem(data, config);
};

Cart.prototype.removeFromCart = function onClickRemoveButton(event) {
  'use strict';

  var attribute = this.getDataAttribute(this.selectors.removeItem);
  var line = Number(event.elem.getAttribute(attribute));
  this.removeItemByLine(line);
};

Cart.prototype.decreaseQuantity = function onClickDecreaseQuantityButton(event) {
  'use strict';

  var attribute = this.getDataAttribute(this.selectors.decreaseQuantity);
  var line = Number(event.elem.getAttribute(attribute));
  var index = line - 1;
  var quantity = this.cart.items[index].quantity - 1;
  var config = {
    beforeRequestType: 'decreaseQuantity'
  };
  this.updateItemByLine(line, quantity, config);
};

Cart.prototype.increaseQuantity = function onClickIncreaseQuantityButton(event) {
  'use strict';

  var attribute = this.getDataAttribute(this.selectors.increaseQuantity);
  var line = Number(event.elem.getAttribute(attribute));
  var index = line - 1;
  var quantity = this.cart.items[index].quantity + 1;
  var config = {
    beforeRequestType: 'increaseQuantity'
  };
  this.updateItemByLine(line, quantity, config);
};
/*
  End Event based Functions
*/

/*
  AJAX API Functions
*/

Cart.prototype.getCart = function getCart(config) {
  'use strict';

  var options = config || {};

  options.success = options.success || function success(response) {
    var cart = JSON.parse(response);
    this.cart = cart;
    var updateEvent = new CustomEvent('cart:updated', {
      detail: {
        response: cart
      }
    });
    document.dispatchEvent(updateEvent);
    return this.cart;
  }.bind(this);
  options.error = options.error || this.defaultError;

  var request = {
    url: this.options.getUrl,
    method: 'GET',
    success: options.success,
    error: options.error
    // Add the request to the ajax request queue
  };this.queue.add(request);
};

// Create an ajax request to add an item the cart
Cart.prototype.addItem = function addItem(data, config) {
  'use strict';

  var item = data || {};
  var options = config || {};
  if (item.id === undefined) {
    return false;
  }
  item.quantity = item.quantity || 1;
  item.properties = item.properties || {};

  // Define callback functions for after the ajax request has been completed
  options.beforeRequestType = options.beforeRequestType || 'addItem';
  options.beforeSend = options.beforeSend || this.defaultBeforeSend;
  options.success = options.success || function success(lineItem) {
    var item = JSON.parse(lineItem);
    this.getCart({
      success: function (response) {
        var cart = JSON.parse(response);
        var addedEvent = new CustomEvent('cart:itemAdded', {
          detail: {
            response: {
              item: item,
              cart: cart
            }
          }
        });
        this.preparingItemsArray = this.createItemArray();
        document.dispatchEvent(addedEvent);
      }.bind(this)
    });
  }.bind(this);
  options.error = options.error || this.defaultError;

  // Build the ajax request
  var request = {
    url: '/cart/add.js',
    data: item,
    success: options.success,
    error: options.error

    // Send a beforeSend event and dd the request to the ajax request queue
  };options.beforeSend(options.beforeRequestType, item.id);
  this.queue.add(request);
  return this;
};

Cart.prototype.removeItemById = function removeItemById(id, config) {
  'use strict';

  var data = {
    updates: {}
  };
  var options = config || {};

  data.updates[id] = 0;

  options.beforeRequestType = options.beforeRequestType || 'removeItemById';
  options.beforeSend = options.beforeSend || this.defaultBeforeSend;
  options.success = options.success || this.defaultSuccess;
  options.error = options.error || this.defaultError;

  var request = {
    url: '/cart/update.js',
    data: data,
    error: options.error,
    success: options.success
  };

  options.beforeSend(options.beforeRequestType, id);
  this.queue.add(request);
  return this;
};

Cart.prototype.removeItemByLine = function removeItemFromCartUsingLineindex(line, config) {
  'use strict';

  var options = config || {};

  options.beforeRequestType = options.beforeRequestType || 'removeItemByLine';
  options.beforeSend = options.beforeSend || this.defaultBeforeSend;
  options.success = options.success || this.defaultSuccess;
  options.error = options.error || this.defaultError;

  var request = {
    url: '/cart/change.js',
    data: {
      line: line,
      quantity: 0
    },
    success: options.success,
    error: options.error
  };

  options.beforeSend(options.beforeRequestType, line);
  this.queue.add(request);
  return this;
};

Cart.prototype.updateItemById = function updateItemById(id, quantity, config) {
  'use strict';

  var data = {
    updates: {}
  };
  var options = config || {};

  data.updates[id] = quantity;

  options.beforeRequestType = options.beforeRequestType || 'updateItemById';
  options.beforeSend = options.beforeSend || this.defaultBeforeSend;
  options.success = options.success || this.defaultSuccess;
  options.error = options.error || this.defaultError;
  var request = {
    url: '/cart/update.js',
    data: data,
    error: options.error,
    success: options.success
  };

  options.beforeSend(options.beforeRequestType, id);
  this.queue.add(request);
  return this;
};

Cart.prototype.updateItemByLine = function updateItemFromCartUsingLineindex(line, qty, config) {
  'use strict';

  clearTimeout(this.requestTimeout);
  var quantity = qty || 0;
  this.preparingItemsArray = this.preparingItemsArray || this.createItemArray();
  this.preparingItemsArray[line - 1] = quantity;
  var sendRequest = function sendRequest() {
    var options = config || {};
    options.beforeRequestType = options.beforeRequestType || 'updateItemByLine';
    options.beforeSend = options.beforeSend || this.defaultBeforeSend;
    options.success = options.success || this.defaultSuccess;
    options.error = options.error || this.defaultError;

    var updates = this.preparingItemsArray;
    var request = {
      url: '/cart/update.js',
      data: {
        updates: updates
      },
      success: options.success,
      error: options.error
    };

    options.beforeSend(options.beforeRequestType, line);
    this.queue.add(request);
    var newArray = [];
    for (var i = 0; i < this.preparingItemsArray.length; i += 1) {
      if (this.preparingItemsArray[i] > 0) {
        newArray.push(this.preparingItemsArray[i]);
      }
    }
    this.preparingItemsArray = newArray;
  }.bind(this);

  this.requestTimeout = setTimeout(sendRequest, this.options.timeOut);

  return this;
};

Cart.prototype.changeItemByLine = function updateItemFromCartUsingLineindex(line, quantity, config) {
  'use strict';

  var options = config || {};

  options.beforeRequestType = options.beforeRequestType || 'changeItemByLine';
  options.beforeSend = options.beforeSend || this.defaultBeforeSend;
  options.success = options.success || this.defaultSuccess;
  options.error = options.error || this.defaultError;
  var data = {
    line: line,
    quantity: quantity
  };

  if (options.properties !== undefined) {
    data.properties = options.properties;
  }

  var request = {
    url: '/cart/change.js',
    data: data,
    success: options.success,
    error: options.error
  };

  options.beforeSend(options.beforeRequestType, data);
  this.queue.add(request);
  return this;
};

Cart.prototype.getShippingRates = function getShippingRates(config) {
  'use strict';

  var options = config || {};

  options.success = options.success || this.defaultSuccess;
  options.error = options.error || this.defaultError;
  var request = {
    url: '/cart/shipping_rates.json?' + options.data,
    method: 'GET',
    success: options.success,
    error: options.error
  };
  this.queue.add(request);
  return this;
};

Cart.prototype.setAttributes = function setCartAttributes(config) {
  'use strict';

  var options = config || {};
  options.beforeRequestType = options.beforeRequestType || 'setAttributes';
  options.beforeSend = options.beforeSend || this.defaultBeforeSend;
  options.success = options.success || this.defaultSuccess;
  options.error = options.error || this.defaultError;
  var attributes = options.attributes || {};
  var data = {
    attributes: attributes
  };
  var request = {
    url: '/cart/update.js',
    success: options.success,
    error: options.error,
    data: data
  };

  if (attributes !== {}) {
    options.beforeSend(options.beforeRequestType, data);
    this.queue.add(request);
  }
  return this;
};
Cart.prototype.setNote = function setCartNote(config) {
  'use strict';

  var options = config || {};
  options.beforeRequestType = options.beforeRequestType || 'setNote';
  options.beforeSend = options.beforeSend || this.defaultBeforeSend;
  options.success = options.success || this.defaultSuccess;
  options.error = options.error || this.defaultError;
  var note = options.note || null;
  var data = {
    note: note
  };
  var request = {
    url: '/cart/update.js',
    success: options.success,
    error: options.error,
    data: data
  };
  options.beforeSend(options.beforeRequestType, data);
  this.queue.add(request);
  return this;
};

/*
  END AJAX API Functions
*/

/*
  Utility Functions
*/

Cart.prototype.getDataAttribute = function getAttributeFromDataAttributeSelector(selector) {
  return selector.replace('[', '').replace(']', '');
};

Cart.prototype.createItems = function createAnIdCentricDataStuctureFromTheCart(cart) {
  var items = {};
  for (var i = 0; i < cart.items.length; i++) {
    items[cart.items[i].id] = {
      line: i + 1,
      quantity: cart.items[i].quantity,
      key: cart.items[i].key
    };
  }
  return items;
};

Cart.prototype.createItemArray = function createAnArrayOfItemsQuantities(cartObj) {
  var array = [];
  var cart = cartObj || this.cart;
  for (var i = 0; i < cart.items.length; i++) {
    array.push(cart.items[i].quantity);
  }
  return array;
};
/*
  End Utility Functions
*/

exports.default = Cart;